import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { TuiSelectOptionComponent } from '@taiga-ui/kit/components/select-option';
import * as i1 from '@taiga-ui/core';
import { TuiPrimitiveCheckboxModule } from '@taiga-ui/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class TuiMultiSelectOptionComponent extends TuiSelectOptionComponent {
    get size() {
        var _a;
        return this.option.size === 'l' ||
            (((_a = this.dataList) === null || _a === void 0 ? void 0 : _a.size) === 'l' && !this.option.size)
            ? 'l'
            : 'm';
    }
    get selected() {
        const { value } = this.option;
        return (tuiIsPresent(value) &&
            tuiIsPresent(this.value) &&
            this.value.some(item => this.matcher(item, value)));
    }
}
TuiMultiSelectOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMultiSelectOptionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
TuiMultiSelectOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiMultiSelectOptionComponent, selector: "tui-multi-select-option", usesInheritance: true, ngImport: i0, template: "<tui-primitive-checkbox\n    class=\"t-checkbox\"\n    [size]=\"size\"\n    [value]=\"selected$ | async\"\n></tui-primitive-checkbox>\n<ng-container [ngTemplateOutlet]=\"context.$implicit\"></ng-container>\n", styles: ["@keyframes retrigger{0%{left:1px}to{left:2px}}:host{display:flex;flex:1;align-items:center;overflow:hidden;animation:retrigger 1s}.t-checkbox{margin-right:.75rem}\n"], components: [{ type: i1.TuiPrimitiveCheckboxComponent, selector: "tui-primitive-checkbox", inputs: ["size", "disabled", "focused", "hovered", "pressed", "invalid", "value"] }], directives: [{ type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i2.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMultiSelectOptionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-multi-select-option',
                    templateUrl: './multi-select-option.template.html',
                    styleUrls: ['./multi-select-option.style.less'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });

class TuiMultiSelectOptionModule {
}
TuiMultiSelectOptionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMultiSelectOptionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiMultiSelectOptionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMultiSelectOptionModule, declarations: [TuiMultiSelectOptionComponent], imports: [CommonModule, TuiPrimitiveCheckboxModule], exports: [TuiMultiSelectOptionComponent] });
TuiMultiSelectOptionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMultiSelectOptionModule, imports: [[CommonModule, TuiPrimitiveCheckboxModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiMultiSelectOptionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TuiPrimitiveCheckboxModule],
                    declarations: [TuiMultiSelectOptionComponent],
                    exports: [TuiMultiSelectOptionComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiMultiSelectOptionComponent, TuiMultiSelectOptionModule };
